import { createTheme } from '@mui/material/styles';

const common = {
    shape: {
        borderRadius: 8,
    },
    typography: {
        h1: {
            fontWeight: 700,
            fontSize: 28,
            lineHeight: 0.85,
            letterSpacing: 0
        },
        h2: {
            fontWeight: 700,
            fontSize: 20,
            lineHeight: 1.2,
            letterSpacing: 0
        },
        h3: {
            fontWeight: 700,
            fontSize: 18,
            letterSpacing: 0
        },
        h4: {
            fontWeight: 700,
            fontSize: 16,
            letterSpacing: 0
        },
        h5: {
            fontWeight: 700,
            fontSize: 15,
            letterSpacing: 0
        },
        h6: {
            fontWeight: 700,
            fontSize: 14,
            letterSpacing: 0
        },
        overline: {
            fontWeight: 500
        },
        button: {
            textTransform: 'none',
            fontSize: 16,
            fontWeight: 700,
            letterSpacing: 0,
            lineHeight: 1.5
        }
    }
}

const theme = createTheme({
    palette: {
        background: {
            default: '#F1F3F4',
            paper: '#ffffff',
            secondary: '#ffffff',
            navbarButton: '#EEF1F5',
            button: '#40B2E0',
            secondaryButton: '#27324D',
            tab: '#F1F7FA',
            selectedTreeView: 'rgba(64, 178, 224, 0.15)',
            toggleButton: '#FFFFFF',
            tablePrimary: '#FFFFFF',
            tableSecondary: '#F1F7FA',
        },
        dashboardLeftSidebar: {
            background: '#FFFFFF'
        },
        settingsDrawer: {
            background: '#FFFFFF',
            color: '#393F42',
            borderLeft: {
                color: '#EEF1F5'
            }
        },
        storeDrawer: {
            background: '#FFFFFF',
            borderLeft: {
                color: '#EEF1F5'
            },
            tabs: {
                backgroundColor: '#F1F7FA',
                button: {
                    backgroundColor: '#40B2E0'
                },
                color: '#ABBCC5',
                list: {
                    backgroundColor: '#F1F7FA',
                    color: '#000',
                    borderBottom: {
                        color: '#F1F7FA'
                    }
                },
                input: {
                    color: '#000'
                },
                label: {
                    color: '#000'
                }
            }
        },
        mapTopSidebar: {
            button: {
                backgroundColor: '#DCE3E7C9',
                color: '#000'
            }
        },
        mapRightSidebar: {
            button: {
                backgroundColor: '#DCE3E7C9',
                color: '#000'
            }
        },
        icons: {
            color: '#ABBCC5',
            default: '#f4f6f8',
        },
        primary: {
            contrastText: '#FFFFFF',
            main: '#40B2E0',
            hover: '#1D97C9'
        },
        secondary: {
            contrastText: '#393F42',
            main: '#FFFFFF',
            hover: '#F1F7FA'
        },
        action: {
            contrastText: '#393F42',
            main: '#ABBCC5'
        },
        black: {
            main: '#000000'
        },
        text: {
            primary: '#393F42',
            secondary: '#ABBCC5',
            tab: '#ABBCC5'
        },
        white: {
            main: '#FFFFFF'
        },
        border: {
            main: '#D2DBE0',
            active: '#40B2E0',
            primary: '#D2DBE0',
            secondary: '#40B2E0',
            drawer: '#EEF1F5',
            color: '#EEF1F5',
            grid: '#9eccd8'
        },
        icon: {
            main: '#D2DBE0'
        },
        backgroundsPreview: {
            background: '#F1F7FA'
        }
    },
    shadows: [
        'none',
        '0 2px 4px 0 rgba(219, 231, 236, 0.40)',
        '0 4px 8px 0 rgba(220, 227, 231, 0.79)',
        '0 4px 8px 0 rgba(64, 178, 224, 0.40)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)'
    ],
    root: {
        backgroundColor: "#FFF",
        "&:hover": {
            // you want this to be the same as the backgroundColor above
            backgroundColor: "#FFF"
        }
    },
    ...common
});

export const darkTheme = createTheme({
    palette: {
        background: {
            default: '#151A26',
            secondary: '#1E2433',
            navbarButton: '#27324D',
            paper: '#1E2433',
            button: '#40B2E0',
            icon: '#fff',
            secondaryButton: '#27324D',
            tab: '#27324D',
            selectedTreeView: 'rgba(50, 63, 95, 1)',
            toggleButton: '#27324D',
            tablePrimary: '#1E2433',
            tableSecondary: '#151A26',
        },
        dashboardLeftSidebar: {
            background: '#1E2433'
        },
        settingsDrawer: {
            background: '#1E2433',
            color: '#FFFFFF',
            borderLeft: {
                color: '#27324D'
            }
        },
        storeDrawer: {
            background: '#1E2433',
            borderLeft: {
                color: '#27324D'
            },
            tabs: {
                backgroundColor: '#27324D',
                button: {
                    backgroundColor: '#40B2E0'
                },
                color: '#FFF',
                list: {
                    backgroundColor: '#151A26',
                    color: '#FFF',
                    borderBottom: {
                        color: '#4C5E74'
                    }
                },
                input: {
                    color: '#FFF'
                },
                label: {
                    color: '#FFF'
                }
            }
        },
        mapTopSidebar: {
            button: {
                backgroundColor: '#27324D',
                color: '#393F42'
            }
        },
        mapRightSidebar: {
            button: {
                backgroundColor: '#27324D',
                color: '#393F42'
            }
        },
        border: {
            main: '#4C5E74',
            active: '#40B2E0',
            color: '#EEF1F5',
            primary: '#4C5E74',
            secondary: '#40B2E0',
            drawer: '#27324D',
            grid: '#1f3a4e'
        },
        icons: {
            color: '#638CA3',
        },
        primary: {
            contrastText: '#ffffff',
            main: '#40B2E0',
            hover: '#1D97C9',
        },
        secondary: {
            contrastText: '#ffffff',
            main: '#27324D',
            hover: '#323F5F',
        },
        action: {
            contrastText: '#ABBCC5',
            main: '#638CA3'
        },
        black: {
            main: '#000000'
        },
        text: {
            primary: '#FFFFFF',
            secondary: '#638CA3',
            tab: '#FFF'
        },
        white: {
            main: '#FFFFFF'
        },
        icon: {
            main: '#638CA3'
        },
        backgroundsPreview: {
            background: '#27324D'
        }
    },
    shadows: [
        'none',
        '0 2px 4px 0 rgba(27, 23, 49, 0.40)',
        '0 2px 4px 0 rgba(27, 23, 49, 0.40)',
        '0 4px 8px 0 rgba(64, 178, 224, 0.20)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)',
        '0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)'
    ],
    root: {
        backgroundColor: "#FFF",
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: "#FFF"
        }
    },
    ...common
});

export default theme;
